"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPiecesForStage = exports.getXpToNextLevel = exports.PlayerCommands = exports.QuickChat = exports.PlayerEvents = exports.ClientUi = exports.GameEvents = exports.PlayerActions = exports.allTraitsMap = exports.allTraits = exports.StreakType = exports.assetPicture = exports.ASSET_PICTURE_PREFIX = exports.creaturePicture = exports.CREATURE_PICTURE_PREFIX = exports.finishedBattle = exports.inProgressBattle = exports.PlayerBattleStatus = exports.PlayerStatus = exports.GamemodeSettingsPresets = exports.PIECES_TO_EVOLVE = exports.MAX_HEALTH = exports.MAX_LEVEL = exports.buildCard = exports.buildPieceModel = exports.buildDefinition = exports.Builders = exports.CreatureRegistry = exports.GamePhase = void 0;
var game_phase_1 = require("./src/game-phase");
Object.defineProperty(exports, "GamePhase", { enumerable: true, get: function () { return game_phase_1.GamePhase; } });
var creatureDefinition_1 = require("./src/creatureDefinition");
Object.defineProperty(exports, "CreatureRegistry", { enumerable: true, get: function () { return creatureDefinition_1.CreatureRegistry; } });
exports.Builders = __importStar(require("./src/builders"));
var builders_1 = require("./src/builders");
Object.defineProperty(exports, "buildDefinition", { enumerable: true, get: function () { return builders_1.buildDefinition; } });
Object.defineProperty(exports, "buildPieceModel", { enumerable: true, get: function () { return builders_1.buildPieceModel; } });
Object.defineProperty(exports, "buildCard", { enumerable: true, get: function () { return builders_1.buildCard; } });
var config_1 = require("./config");
Object.defineProperty(exports, "MAX_LEVEL", { enumerable: true, get: function () { return config_1.MAX_LEVEL; } });
Object.defineProperty(exports, "MAX_HEALTH", { enumerable: true, get: function () { return config_1.MAX_HEALTH; } });
Object.defineProperty(exports, "PIECES_TO_EVOLVE", { enumerable: true, get: function () { return config_1.PIECES_TO_EVOLVE; } });
var settings_1 = require("./settings");
Object.defineProperty(exports, "GamemodeSettingsPresets", { enumerable: true, get: function () { return settings_1.GamemodeSettingsPresets; } });
var playerList_1 = require("./game/playerList");
Object.defineProperty(exports, "PlayerStatus", { enumerable: true, get: function () { return playerList_1.PlayerStatus; } });
Object.defineProperty(exports, "PlayerBattleStatus", { enumerable: true, get: function () { return playerList_1.PlayerBattleStatus; } });
Object.defineProperty(exports, "inProgressBattle", { enumerable: true, get: function () { return playerList_1.inProgressBattle; } });
Object.defineProperty(exports, "finishedBattle", { enumerable: true, get: function () { return playerList_1.finishedBattle; } });
var player_1 = require("./player");
Object.defineProperty(exports, "CREATURE_PICTURE_PREFIX", { enumerable: true, get: function () { return player_1.CREATURE_PICTURE_PREFIX; } });
Object.defineProperty(exports, "creaturePicture", { enumerable: true, get: function () { return player_1.creaturePicture; } });
Object.defineProperty(exports, "ASSET_PICTURE_PREFIX", { enumerable: true, get: function () { return player_1.ASSET_PICTURE_PREFIX; } });
Object.defineProperty(exports, "assetPicture", { enumerable: true, get: function () { return player_1.assetPicture; } });
Object.defineProperty(exports, "StreakType", { enumerable: true, get: function () { return player_1.StreakType; } });
var traits_1 = require("./gamemode/traits");
Object.defineProperty(exports, "allTraits", { enumerable: true, get: function () { return traits_1.allTraits; } });
Object.defineProperty(exports, "allTraitsMap", { enumerable: true, get: function () { return traits_1.allTraitsMap; } });
// Wire vocabulary - neutral protocol package the host and plugins both
// import from, so the host never reaches into a specific plugin for
// vocabulary (the agnostic-host principle).
exports.PlayerActions = __importStar(require("./src/wire/playerActions"));
__exportStar(require("./src/wire/playerActions"), exports);
__exportStar(require("./src/wire/quickChat"), exports);
exports.GameEvents = __importStar(require("./src/wire/gameEvents"));
__exportStar(require("./src/wire/gameEvents"), exports);
exports.ClientUi = __importStar(require("./src/wire/clientUi"));
__exportStar(require("./src/wire/clientUi"), exports);
exports.PlayerEvents = __importStar(require("./src/wire/playerEvents"));
__exportStar(require("./src/wire/playerEvents"), exports);
exports.QuickChat = __importStar(require("./src/wire/quickChat"));
exports.PlayerCommands = __importStar(require("./src/wire/playerCommands"));
__exportStar(require("./src/wire/playerCommands"), exports);
// Utility funcs the client legitimately needs for display (compute
// from local state). Lives here, not in a specific plugin.
var xp_1 = require("./src/utils/xp");
Object.defineProperty(exports, "getXpToNextLevel", { enumerable: true, get: function () { return xp_1.getXpToNextLevel; } });
var evolution_1 = require("./src/utils/evolution");
Object.defineProperty(exports, "getPiecesForStage", { enumerable: true, get: function () { return evolution_1.getPiecesForStage; } });
